// Sixes (Hollywood / Round Robin) — ported verbatim from GolfGamesScorecard's
// calcSixes (utils/scoring.ts). 4 players; partners rotate every 6 holes across
// the three 2v2 pairings. Verbatim behavior preserved (including that both
// compared players score a win when one pair-side is lower).
export function calcSixes(players) {
  const pairings = [
    [[0, 1], [2, 3]], // holes 1–6
    [[0, 2], [1, 3]], // holes 7–12
    [[0, 3], [1, 2]], // holes 13–18
  ]
  const wins = {}
  players.forEach((p) => { wins[p.id] = 0 })
  pairings.forEach((pairing, segment) => {
    const start = segment * 6
    pairing.forEach(([a, b]) => {
      const aScore = players[a].scores.slice(start, start + 6).reduce((s, v) => s + (v ?? 0), 0)
      const bScore = players[b].scores.slice(start, start + 6).reduce((s, v) => s + (v ?? 0), 0)
      if (aScore < bScore) { wins[players[a].id]++; wins[players[b].id]++ }
      else if (bScore < aScore) { wins[players[b].id]++; wins[players[a].id]++ }
    })
  })
  return players.map((p) => ({ ...p, wins: wins[p.id] })).sort((a, b) => b.wins - a.wins)
}
